module.exports = __webpack_public_path__ + "static/media/explore-1a.f5f65f67.jpeg";